import { Card, Carousel, Typography } from "antd";
import styled from "styled-components";

export const TaskDescriptionBlock = styled(Card)`
    margin-top: 8px;
    gap: 16px;
    border-radius: 10px;
    border: none;
    width: 100%;
`;

export const DocumentItem = styled.div`
    padding: 12px 0;
    width: 100%;
    border-bottom: 1px solid #313131;
`;

export const TaskDescriptionText = styled(Typography)`
    width: 50%;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    && {
        color: ${(props) => props.theme.secondaryTypographyColor};
    }
`;

export const ImageWrapper = styled.div`
    height: 300px;
    margin: auto;
`;

export const CarouselWrapper = styled.div`
    .ant-image {
        height: 300px;
        width: auto;
        display: flex;
        justify-content: center;
    }
    img {
        width: auto !important;
    }
`;

export const StyledCarousel = styled(Carousel)`
    > .slick-dots li {
        background-color: #344dc8;
        opacity: 0.8;
        width: 30px;
    }
    > .slick-dots li.slick-active button {
        background-color: #344dc8;
    }
`;

export const StyledText = styled(Typography)`
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    text-align: right;
    color: #5f5f5f;
    margin: 16px 0;
`;

export const StyledTitle = styled(Typography)`
    font-size: 20px;
    font-weight: 500;
    line-height: 20px;
    text-align: center;
    padding-bottom: 16px;
`;
